var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongTermOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70337 11.5C3.42723 11.5 3.20337 11.2761 3.20337 11V5C3.20337 4.72386 3.42723 4.5 3.70337 4.5H3.75952C4.03566 4.5 4.25952 4.72386 4.25952 5V10.5908H6.97681C7.22787 10.5908 7.4314 10.7943 7.4314 11.0454C7.4314 11.2965 7.22787 11.5 6.97681 11.5H3.70337Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83386 5.40918C7.5828 5.40918 7.37927 5.20565 7.37927 4.95459C7.37927 4.70353 7.5828 4.5 7.83386 4.5H12.3422C12.5932 4.5 12.7968 4.70353 12.7968 4.95459C12.7968 5.20565 12.5932 5.40918 12.3422 5.40918H10.6127V11C10.6127 11.2761 10.3888 11.5 10.1127 11.5H10.0599C9.78379 11.5 9.55994 11.2761 9.55994 11V5.40918H7.83386Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongTermOutline);
export default __webpack_public_path__ + "static/media/longTermOutline.f9b048e408414e5a12b762b19e1a792f.svg";
export { ForwardRef as ReactComponent };